module.exports = __webpack_public_path__ + "img/Loyalty-ability-01.0cf8bfac.png";